const FILTER_OPTIONS_ENUM = [
  {
    name: 'recipients.filter.id',
    type: 'text',
    name_query: 'ids'
  },
  {
    name: 'recipients.filter.name',
    type: 'text',
    name_query: 'names'
  },
  {
    name: 'recipients.filter.document',
    type: 'number',
    name_query: 'documents'
  },
  {
    name: 'recipients.filter.status.title',
    type: 'select',
    name_query: 'status',
    select_options: [
      {
        id: 'refused',
        text: 'recipients.filter.status.refused'
      },
      {
        id: 'active',
        text: 'recipients.filter.status.active'
      },
      {
        id: 'affiliation',
        text: 'recipients.filter.status.affiliation'
      },
      {
        id: 'inactive',
        text: 'recipients.filter.status.inactive'
      },
      {
        id: 'registration',
        text: 'recipients.filter.status.registration'
      },
      {
        id: 'deleted',
        text: 'recipients.filter.status.deleted'
      },
      {
        id: 'suspended',
        text: 'recipients.filter.status.suspended'
      },
      {
        id: 'blocked',
        text: 'recipients.filter.status.blocked'
      }
    ]
  },
  {
    name: 'recipients.filter.bank_account',
    type: 'text',
    name_query: 'anyIds'
  }
]

export default FILTER_OPTIONS_ENUM
